<div [class]="footerStyle" class="mt-lg-20 pb-10" id="kt_footer">
    <div class="footerPatt mt-n16"></div>
    <div class="container d-flex justify-content-center justify-content-lg-end my-5 my-lg-10">
        <a routerLink="/" target="_blank">
            <img alt="Logo" src="/assets/common/images/logo-on-light.png" class="logo-default" />
        </a>
    </div>

    <div class="container d-flex flex-column flex-lg-row align-items-center justify-content-between">
        <div class="text-dark order-2 order-md-1">
            <span class="text-white font-weight-bold mr-2">
                جميع الحقوق محفوظة للمركز السعودي لكفاءة الطاقة © 2022
            </span>
        </div>
        <div class="nav order-1 order-md-2">
            
            <a [routerLink]="['/faq']" class="nav-link text-white pr-lg-0 pl-lg-12">الاسئلة الشائعة</a>
            <a [routerLink]="['/policies-terms']" class="nav-link text-white pr-lg-0 pl-lg-12">سياسة وشروط الخصوصية</a>
            <a [routerLink]="['/terms-of-use']" class="nav-link text-white pr-lg-0 pl-lg-12">أحكام الاستخدام</a>
            
        </div>
    </div>
</div>